module.exports = __webpack_public_path__ + "static/img/item1-bottom.81a9391d.png";